module.exports = __webpack_public_path__ + "static/logo_home-f3ed37c9579ab4d7fd9fd3f4e2ab0483.gif";